// Mega menu static image toggler
(function () {
  var RESTORE_DELAY = 80;

  function isDesktop() {
    return window.matchMedia('(min-width: 751px)').matches;
  }

  function getDropdownState(dropdown) {
    if (!dropdown._megaStaticState) {
      dropdown._megaStaticState = { restoreTimer: null };
    }
    return dropdown._megaStaticState;
  }

  function clearRestoreTimer(dropdown) {
    if (!dropdown) return;
    var state = getDropdownState(dropdown);
    if (state.restoreTimer) {
      clearTimeout(state.restoreTimer);
      state.restoreTimer = null;
    }
  }

  function findStaticElement(dropdown, handle) {
    if (!dropdown) return null;
    if (handle) {
      var scoped = dropdown.querySelector('.menu__static[data-static-handle="' + handle + '"]');
      if (scoped) return scoped;
    }
    return dropdown.querySelector('.menu__static');
  }

  function hideStatic(link) {
    var dropdown = link.closest('.header__dropdown');
    if (!dropdown) return;

    clearRestoreTimer(dropdown);

    var handle = link.getAttribute('data-menu-handle');
    var staticEl = findStaticElement(dropdown, handle);
    if (staticEl) {
      staticEl.classList.add('is-hidden');
    }
  }

  function restoreStatic(dropdown) {
    if (!dropdown) return;
    clearRestoreTimer(dropdown);
    dropdown.querySelectorAll('.menu__static').forEach(function (el) {
      el.classList.remove('is-hidden');
      if (el.style.opacity) el.style.opacity = '';
      if (el.style.display) el.style.display = '';
    });
  }

  function scheduleRestore(dropdown) {
    if (!dropdown) return;
    clearRestoreTimer(dropdown);
    var state = getDropdownState(dropdown);
    state.restoreTimer = setTimeout(function () {
      state.restoreTimer = null;
      restoreStatic(dropdown);
    }, RESTORE_DELAY);
  }

  function linkHasHover(link) {
    var handle = link.getAttribute('data-menu-handle');
    if (!handle) return false;
    var dropdown = link.closest('.header__dropdown');
    if (!dropdown) return false;
    return !!dropdown.querySelector('[data-block-handle="' + handle + '"]');
  }

  function handleEnter(link, options) {
    if (!isDesktop()) return;

    if (!linkHasHover(link)) {
      restoreStatic(link.closest('.header__dropdown'));
      return;
    }

    hideStatic(link);

    if (options && options.fromFocus && !link.dataset.megaStaticSynthetic) {
      link.dataset.megaStaticSynthetic = '1';
      try {
        link.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
      } catch (err) {
        link.dispatchEvent(new Event('mouseenter', { bubbles: true }));
      }
      setTimeout(function () {
        delete link.dataset.megaStaticSynthetic;
      }, 0);
    }
  }

  function bindLink(link) {
    if (link.dataset.megaStaticBound) return;

    link.addEventListener(
      'mouseenter',
      function () {
        if (link.dataset.megaStaticSynthetic) return;
        handleEnter(link);
      },
      { passive: true }
    );

    link.addEventListener('focusin', function () {
      handleEnter(link, { fromFocus: true });
    });

    link.addEventListener(
      'mouseleave',
      function (event) {
        if (!isDesktop()) return;
        var dropdown = link.closest('.header__dropdown');
        if (!dropdown) return;
        // If the mouse moved into the dropdown (or a child), don't schedule restore.
        var related = event.relatedTarget;
        try {
          if (related && dropdown.contains(related)) return;
        } catch (err) {
          // defensive: if contains throws, fall back to scheduling
        }
        scheduleRestore(dropdown);
      },
      { passive: true }
    );

    link.dataset.megaStaticBound = '1';
  }

  function bindDropdown(dropdown) {
    restoreStatic(dropdown);

    if (dropdown.dataset.megaStaticDropdownBound) return;

    // Ensure the static image area is clickable even if overlays intercept
    // native clicks. This adds a delegated click handler to the scoped
    // .menu__static element which will navigate to the anchor href when
    // the static is visible.
    try {
      var staticEl = findStaticElement(dropdown);
      if (staticEl && !staticEl.dataset.megaStaticClickBound) {
        staticEl.addEventListener('click', function (evt) {
          // don't handle clicks when static is hidden
          if (staticEl.classList.contains('is-hidden')) return;

          // prefer a real anchor if present
          var a = staticEl.querySelector('a');
          var href = null;
          if (a && a.href) {
            href = a.href;
          } else if (staticEl.dataset && staticEl.dataset.staticUrl) {
            // fallback to the dataset provided by the Liquid template
            href = staticEl.dataset.staticUrl || null;
          } else {
            // last-resort fallback: use the image src if available
            var img = staticEl.querySelector('img');
            if (img && img.src) href = img.src;
          }

          if (href) {
            // allow modifier keys to work (open in new tab) by checking
            // for ctrl/meta/shift/alt — if present, don't override default
            if (evt.ctrlKey || evt.metaKey || evt.shiftKey || evt.altKey) return;
            evt.preventDefault();
            window.location.href = href;
          }
        }, { passive: false });
        staticEl.dataset.megaStaticClickBound = '1';
      }
    } catch (err) {
      /* ignore */
    }

    dropdown.addEventListener(
      'mouseleave',
      function (event) {
        if (!isDesktop()) return;
        if (dropdown.contains(event.relatedTarget)) return;
        scheduleRestore(dropdown);
      },
      { passive: true }
    );

    dropdown.addEventListener('focusout', function (event) {
      if (!isDesktop()) return;
      var next = event.relatedTarget;
      if (next && dropdown.contains(next)) return;
      restoreStatic(dropdown);
    });

    dropdown.dataset.megaStaticDropdownBound = '1';
  }

  function init() {
    document.querySelectorAll('[data-menu-handle]').forEach(bindLink);
    document.querySelectorAll('.header__dropdown').forEach(function (dropdown) {
      // ensure static is visible by default on init
      restoreStatic(dropdown);
      bindDropdown(dropdown);
    });
  }

  function watchEditor() {
    document.addEventListener('shopify:section:load', function () {
      setTimeout(init, 50);
    });
    document.addEventListener('shopify:section:unload', function () {
      setTimeout(init, 50);
    });
    document.addEventListener('shopify:section:select', function () {
      setTimeout(init, 50);
    });
  }

  function observeDom() {
    try {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          // handle newly added nodes
          if (mutation.addedNodes && mutation.addedNodes.length) {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType !== 1) return;

              if (node.matches && node.matches('[data-menu-handle]')) {
                bindLink(node);
              }
              if (node.matches && node.matches('.header__dropdown')) {
                bindDropdown(node);
              }

              if (node.querySelectorAll) {
                node.querySelectorAll('[data-menu-handle]').forEach(bindLink);
                node.querySelectorAll('.header__dropdown').forEach(bindDropdown);
              }
            });
          }

          // handle attribute changes (class toggles) so we can react when
          // a hover block gains/loses the `visible` class even if mouse events
          // were missed by the handlers.
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var target = mutation.target;
            try {
              if (target && target.nodeType === 1 && target.matches && target.matches('[data-block-handle]')) {
                var dd = target.closest('.header__dropdown');
                var handle = target.getAttribute('data-block-handle');
                // if the block gained visible, immediately hide the static for its dropdown
                if (target.classList.contains('visible')) {
                  try {
                    if (dd && handle) {
                      // find the corresponding link in this dropdown and hide static via existing API
                      var link = dd.querySelector('[data-menu-handle="' + handle + '"]');
                      if (link) {
                        hideStatic(link);
                      } else {
                        // fallback: directly add is-hidden to the scoped static element
                        var staticEl = findStaticElement(dd, handle);
                        if (staticEl) staticEl.classList.add('is-hidden');
                      }
                    }
                  } catch (err) {
                    /* ignore */
                  }
                } else {
                  // if the block just lost visible, schedule restore for the dropdown
                  if (dd) {
                    scheduleRestore(dd);
                  }
                }
              }
            } catch (err) {
              /* ignore */
            }
          }
        });
      });
      // Observe both child additions and attribute changes (class toggles)
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    } catch (err) {
      /* noop */
    }
  }

  function start() {
    init();
    watchEditor();
    observeDom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
